import { RenderIf } from "utilities/helpers";
import { Column, Row } from "layouts/container";
import { Button } from "components/button";
import ValueBgBx from './../../assets/svgs/value_bg_bx.svg';
import ValueBgBxC3 from './../../assets/svgs/value_bg_bx_c3.svg';
import { Ikon } from "assets/icons";
import styles from './index.module.css';
import React from "react";

export const CardV1 = ({
    title,
    isBgImg = true,
    isView = true,
    filterTxt,
    value,
    filterValue,
    percentage,
}) => {

    return (
        <Column gap={8} padding={'21px 14px 6px'} style={{ 
            flex: 1, 
            background: '#FFFFFF',
            backgroundImage: isBgImg ? `url(${ValueBgBx})` : '',
            backgroundRepeat: isBgImg ? 'no-repeat' : '',
            backgroundSize: isBgImg ? '100% auto' : '',
            backgroundPosition: isBgImg ? 'right bottom' : '',
            borderRadius: 16,
        }}>
            <Column gap={1}>
              <Row gap={10} justifyContent={'space-between'}>
                <h6 className={styles.cardSubHead}>{title}</h6>
                <RenderIf isTrue={isView}>
                    <Button 
                    onClick={() => {}} 
                    style={{
                        padding: 0,
                        height: 'auto',
                        borderRadius: 0,
                        background: 'transparent',
                        color: 'var(--primary)',
                        fontWeight: '500',
                        fontSize: 10,
                        gap: 2,
                    }} 
                    >
                    View
                    <Ikon name={'view-cert'} />
                    </Button>
                </RenderIf>
              </Row>
              <div>
                <Button 
                  onClick={() => {}} 
                  style={{
                    padding: 0,
                    height: 'auto',
                    borderRadius: 0,
                    background: 'transparent',
                    color: '#828282',
                    fontWeight: '400',
                    fontSize: 8,
                    alignItems: 'center',
                    gap: 4,
                  }} 
                >
                    {filterTxt}
                    <Ikon name={'dd-cert-xs'} />
                </Button>
              </div>
            </Column>
            <Column gap={'0'} alignItems={'center'} margin={'6px 0 0'}>
              <h2 className={styles.h2_c1}>{value}</h2>
            </Column>
            <Row gap={10} justifyContent={'space-between'}>
              <Column gap={4}>
                <RenderIf isTrue={filterValue}>
                    <p className={styles.p1_c1}>{filterValue}</p>
                </RenderIf>
                <RenderIf isTrue={percentage}>
                    <Row gap={4} alignItems={'center'}>
                    <Ikon name={'plus-arrow'} />
                    <p className={styles.p2_c1}>{percentage}</p>
                    </Row>
                </RenderIf>
              </Column>
            </Row>
        </Column>
    );
}

export const CardV2 = ({
    title,
    isBgImg = false,
    isView = true,
    items = [],
}) => {

    return (
        <Column gap={8} padding={'21px 14px 6px'} style={{ 
            flex: 1, 
            background: '#FFFFFF',
            backgroundImage: isBgImg ? `url(${ValueBgBx})` : '',
            backgroundRepeat: isBgImg ? 'no-repeat' : '',
            backgroundSize: isBgImg ? '100% auto' : '',
            backgroundPosition: isBgImg ? 'right bottom' : '',
            borderRadius: 16,
        }}>
            <Column gap={1}>
              <Row gap={10} justifyContent={'space-between'}>
                <h6 className={styles.h6_c2}>{title}</h6>
                <RenderIf isTrue={isView}>
                    <Button 
                        onClick={() => {}} 
                        style={{
                            padding: 0,
                            height: 'auto',
                            borderRadius: 0,
                            background: 'transparent',
                            color: 'var(--primary)',
                            fontWeight: '500',
                            fontSize: 10,
                            gap: 2,
                        }} 
                    >
                        View
                        <Ikon name={'view-cert'} />
                    </Button>
                </RenderIf>
              </Row>
            </Column>
            <Row gap={6} justifyContent={'space-between'}>
                <RenderIf isTrue={items?.length > 0}>
                    {items?.map((item, index) => (
                        <React.Fragment key={index}>
                            <Column gap={3} alignItems={'center'} style={{ flex: 1, }}>
                                <Ikon name={item?.icon} />
                                <p className={styles.p1_c2}>{item?.value}</p>
                                <p className={styles.p2_c2}>{item?.title}</p>
                            </Column>
                            <RenderIf isTrue={index !== items?.length - 1}>
                                <Column gap={'0'} width={1} style={{ background: 'linear-gradient(270deg, rgba(0, 0, 0, 0) -0.58%, rgba(0, 0, 0, 0.13) 48.61%, rgba(0, 0, 0, 0) 98.84%)' }}></Column>
                            </RenderIf>
                        </React.Fragment>
                    ))}
                </RenderIf>
            </Row>
        </Column>
    );
}

export const CardV3 = ({
    title,
    isBgImg = true,
    description,
    butnTxt,
}) => {

    return (
        <Column gap={1} padding={'21px 14px 10px'} width={305} style={{  
            background: 'var(--primary)',
            backgroundImage: isBgImg ? `url(${ValueBgBxC3})` : '',
            backgroundRepeat: isBgImg ? 'no-repeat' : '',
            backgroundSize: isBgImg ? 'auto 100%' : '',
            backgroundPosition: isBgImg ? 'right top' : '',
            borderRadius: 16,
        }}>
            <h6 className={styles.h6_c3}>{title}</h6>
            <Column gap={10}>
                <p className={styles.p1_c3}>{description}</p>
                <div>
                    <Button 
                        onClick={() => {}} 
                        style={{
                            padding: '8px 20px',
                            height: 'auto',
                            borderRadius: 24,
                            background: '#FFFFFF',
                            color: '#262626',
                            fontWeight: '600',
                            fontSize: 10,
                        }} 
                    >
                        {butnTxt}
                    </Button>
                </div>
            </Column>
        </Column>
    );
}